import React from 'react';
import classnames from 'classnames';
import Who from '../../Who';
import { isSimpleDeviation } from '../../DeviationViews/_helpers';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
var offsetModifier = [0, 0];
import s from './WhoTooltipWrapper.scss';
var WhoTooltipWrapper = function (_a) {
    var deviation = _a.deviation, userListType = _a.userListType, tooltipDataHook = _a.tooltipDataHook, dataHook = _a.dataHook, className = _a.className, children = _a.children;
    var _b = usePopoverOnInteraction({
        listenOnHover: true,
        hideOnScroll: false,
    }), isVisible = _b.isVisible, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave;
    var noHover = isSimpleDeviation(deviation);
    if (noHover) {
        return (React.createElement("span", { className: classnames(s['tooltip-wrapper'], className), "data-hook": dataHook }, children));
    }
    return (React.createElement("span", { className: classnames(s['root'], className), "data-hook": dataHook, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement(PositionOnlyPopperPopover, { isVisible: isVisible, popoverContent: React.createElement(Who, { deviation: deviation, userListType: userListType, dataHook: tooltipDataHook }), directionalClassNames: {
                top: s['tooltip-top'],
                bottom: s['tooltip-bottom'],
            }, wrapperClassName: s['tooltip-wrapper'], offsetModifier: offsetModifier, usePortal: false }, children)));
};
WhoTooltipWrapper.displayName = 'WhoTooltipWrapper';
export default WhoTooltipWrapper;
//# sourceMappingURL=WhoTooltipWrapper.js.map